import angular from 'angular';

export default function MemberBidsOffersDetailCtrl($scope, BidsOffersService, $stateParams, $uiViewScroll, $mdMedia) {
  let subscription = BidsOffersService.get($stateParams.id)
      .safeApply($scope, function (bo) {
        $scope.bid = bo;
      }).subscribe();

  // Combo: the other parts of this bid/offer's combo (empty when it isn't a combo).
  $scope.isCombo = BidsOffersService.isCombo;
  $scope.comboParts = [];
  $scope.comboCount = 0;

  let comboSubscription = BidsOffersService.comboParts($stateParams.id)
      .safeApply($scope, function (parts) {
        $scope.comboCount = parts.length;
        $scope.comboParts = parts.filter(function (part) {
          return part.BoID !== $stateParams.id;
        });
      }).subscribe();

  $scope.mdMedia = $mdMedia;

  $scope.$on("$destroy", function () {
    subscription.dispose();
    comboSubscription.dispose();
  });

  $uiViewScroll(angular.element('#scroll-top'));
}
